<template>
  <div class="dialog-box">
    <div class="box-title">全国</div>
    <div class="update-time">
      数据截止到  {{ time }}
    </div>
    <div class="flex-3"></div>
    <div class="top-box">
      <div :class="(index===0||index===1||index===2)?'box-item-top':'box-item'" v-for="(i,index) of dataList">
        <div class="image-box">
          <img height="100%" v-if="index===0||index===1||index===2"
            :src="`https://survey.iscn.org.cn/system/mallMiniProgram/img/dataReport/top${index+1}.png`"
          />
          <span v-else>{{ index+1 }}</span>
        </div>
        <div>
          {{ i.name }}
        </div>
      </div>
      <div class="box-item" v-for="index of (10-dataList.length)" :key="index">
        <div class="image-box">
          <span></span>
        </div>
        <div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dataList: {
      type: Array,
      default: [],
    },
    time: {
      type: String,
      default: '',
    }
  },
  name: 'MyTop',
  data() {
    return {
      title: 'Welcome to My Component',
      message: 'This is my custom component',
    };
  },
};
</script>
<style scoped>
  .dialog-box {
    width: 100%;
    height: 100%;
    margin:0px;
    background: #CE1F26;
    background: url(https://survey.iscn.org.cn/system/mallMiniProgram/img/2024dataReport/wordTop.jpg) no-repeat;
    background-size: cover;
    /* background-position: center; */
    display: flex;
    flex-direction: column;
    font-size: 12px;
  }
  .box-title {
    padding-top: 2%;
    padding-left: 10%;
  }
  .update-time {
    margin-top: 25%;
    text-align: center;
    font-size: 12px;
    color: #FC4200;
    text-shadow: 0px 0px 10px #fff,0px 0px 20px #fff,0px 0px 30px #fff;
  }
  .flex-3 {
    flex: 3;
  }
  .top-box {
    background: #fff ;
    flex:7;
    display: flex;
    flex-direction: column;
    margin: 0 20px 15px 20px;
    padding: 10px;
  }
  .box-item {
    flex: 1;
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0 20px;
    margin-bottom: 5px;
  }
  .box-item-top {
    flex: 1;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-bottom: 5px;
    border: none;
    padding: 0 20px;
  }
  .box-item-top>div:nth-child(1){
    flex: 1;
  }
  .box-item-top>div:nth-child(2){
    width: 140px;
    text-align: center;
  }
  .box-item>div:nth-child(1){
    flex: 1;
  }
  .box-item>div:nth-child(2){
    width: 140px;
    text-align: center;
  }
  .top-box>div:nth-child(1){
    background: #FFD76F;
    border-radius: 5px;
  }
  .top-box>div:nth-child(2) {
    border-radius: 5px;
    background: #DCDCDC;
  }
  .top-box>div:nth-child(3) {
    border-radius: 5px;
    background: #FFC197;
  }
  .image-box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
  }
  .image-box img{
    max-width: 30px;
    /* max-height: 50px; */
  }
  @media screen and (max-width: 350px) {
    .update-time {
      margin-top: 27%;
    }
    .flex-3 {
      flex: 2;
    }
    .top-box {
      flex:6;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/top.vue